(function(){
  if(!window.matchMedia||!window.matchMedia('(max-width: 719px)').matches)return;

  var styleId='noomadic-mobile-pinch-zoom-style';
  var style=document.getElementById(styleId);
  if(!style){
    style=document.createElement('style');
    style.id=styleId;
    document.head.appendChild(style);
  }

  style.textContent='@media(max-width:719px){' +
    'body.template-product.noomadic-refined-surface .tt-pdp .product-gallery--slider,' +
    'body.template-product.noomadic-refined-surface .tt-pdp .product-gallery--slider .flickity-viewport,' +
    'body.template-product.noomadic-refined-surface .tt-pdp .product-gallery--slider .flickity-slider,' +
    'body.template-product.noomadic-refined-surface .tt-pdp .product-gallery--image,' +
    'body.template-product.noomadic-refined-surface .tt-pdp .product-gallery--image img{' +
      'touch-action:pan-y pinch-zoom!important;' +
      '-ms-touch-action:pan-y pinch-zoom!important;' +
    '}' +
  '}';

  function inProductGallery(target){
    return !!(target&&target.closest&&target.closest('.tt-pdp .product-gallery--slider'));
  }

  function releaseEmpireLock(event){
    if(event.touches&&event.touches.length>1&&inProductGallery(event.target)){
      document.ontouchmove=null;
    }
  }

  document.addEventListener('touchstart',releaseEmpireLock,true);
  document.addEventListener('touchmove',releaseEmpireLock,true);
})();
